module.exports = __webpack_public_path__ + "static/media/hero-mob.6b7f58ba.jpg";